function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, nft_overlay) {
  var html = "\n    <div class=\"saito-nft-panel saito-nft-panel-send\">\n      <div class=\"saito-nft-panel-body\">\n        <div id='transfer-info-panel'>\n          <h2 class=\"saito-nft-mode-title\">Send NFT</h2>\n          <label class=\"saito-nft-input-label\">Recipient Address</label>\n          <input class=\"saito-nft-input-field\" id=\"nft-receiver-address\"/>\n        </div>\n  ";
  var splitUtxosHtml = '';
  var utxoIdx = 0;
  var _iterator = _createForOfIteratorHelper(nft_overlay.nft.returnAllSlips()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      utxoIdx++;
      var uuid = 'N/A';
      if (slip.slip1) {
        var blockId = slip.slip1.block_id || 'N/A';
        var txOrdinal = slip.slip1.tx_ordinal || 'N/A';
        var slipIndex = slip.slip1.slip_index !== undefined ? slip.slip1.slip_index : 'N/A';
        uuid = "".concat(blockId, "-").concat(txOrdinal, "-").concat(slipIndex);
      }
      var amount = Number(slip.slip1.amount) || 0;
      splitUtxosHtml += "\n        <div class=\"".concat(utxoIdx == 1 ? 'selected-shard' : '', " nft-slip-box utxo-").concat(utxoIdx, "\" data-utxo-idx=\"").concat(utxoIdx, "\">\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">UUID:</div>\n            <div class=\"nft-slip-box-value\">").concat(uuid, "</div>\n          </div>\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">amount:</div>\n            <div class=\"nft-slip-box-value\">").concat(slip.slip1.amount, "</div>\n          </div>\n          <div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">deposit:</div>\n            <div class=\"nft-slip-box-value\">").concat(app.wallet.convertNolanToSaito(slip.slip2.amount), " SAITO</div>\n          </div>\n        </div>\n      ");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "\n        <div class=\"nft-slips-container\">\n          <div class=\"nft-slips-title\">AVAILABLE SHARDS</div>\n          <div class=\"nft-slips-flex\">\n            ".concat(splitUtxosHtml, "\n          </div>\n        </div>\n      </div>\n      \n      <div class=\"saito-nft-panel-footer\">\n        <button class=\"saito-nft-footer-btn saito-button-secondary saito-nft-cancel-btn\">Cancel</button>\n        <button class=\"saito-nft-footer-btn saito-nft-confirm-btn\">Confirm</button>\n      </div>\n    </div>\n    ");
  return html;
};